import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { appRegistrySetup } from './setup';

/**
 * @typedef {object} Consent
 * @property {string} appId
 * @property {'ALLOWED' | 'DENIED' | 'REQUESTED'} status
 * @property {string} appType
 * @property {string} submittedBy
 * @property {string} submittedOn
 * @property {string | null} submissionNotes
 * @property {string | null} reviewedBy
 * @property {string | null} reviewedOn
 * @property {string | null} reviewerNotes
 * @property {string} createdBy
 * @property {string} createdOn
 * @property {string} lastModifiedBy
 * @property {string} lastModifiedOn
 */

/**
 * @typedef {object} User
 * @property {string} guid
 * @property {string} email
 */

/**
 * @typedef {object} ConsentResponse
 * @property {string} orgId
 * @property {Consent[]} consents
 * @property {User[]} user
 */

/**
 * Update consents for the user's org's Enterprise Entitlement
 * @param {object} params
 * @param {object} signal
 * @returns {Promise<ConsentResponse>}
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'orgId', 'appIds'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    appIds: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${appRegistrySetup.endpoint}/entitlement-api/v2/enterprise/consent?appId=${params.appIds}`,
    {
      signal,
      headers: { 'x-api-key': appRegistrySetup.apiKey, Authorization: params.accessToken, 'x-org-id': params.orgId },
    }
  );

  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content ?? {};
  }
};
